// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"GroupsandPermissionsPanel_tagsContainer__1X1ZW","groupTag":"GroupsandPermissionsPanel_groupTag__1Bptf","addButton":"GroupsandPermissionsPanel_addButton__31vPr"};